import React, { useState } from 'react';
import { Map } from './components/Map';
import { MapMode } from './types';
import './App.css';

function App() {
  const [mapMode, setMapMode] = useState<MapMode>('view');

  return (
    <div className="App">
      <header className="app-header">
        <h1>Mussel Farm Digital Twin</h1>
        <p>Spanish Coast Management System</p>
      </header>
      <main className="app-main">
        <Map mode={mapMode} setMode={setMapMode} />
      </main>
    </div>
  );
}

export default App;
